var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.257,
    height: 26.214,
    viewBox: "0 0 27.257 26.214",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6013",
    "data-name": "Group 6013",
    transform: "translate(-7652.335 -602.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6012",
    "data-name": "Group 6012",
    transform: "translate(7652.435 604.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6011",
    "data-name": "Group 6011",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6466",
    "data-name": "Path 6466",
    d: "M7670.1,612.96c-.793.784-1.517,1.509-2.259,2.215a.7.7,0,0,1-.441.1q-5.443.008-10.885,0a1.534,1.534,0,0,0-1.75,1.735c0,4.775.008,9.551-.008,14.326a1.632,1.632,0,0,0,1.757,1.751q7.183-.049,14.366,0a1.634,1.634,0,0,0,1.732-1.737c-.026-2.921,0-5.842-.017-8.764a.969.969,0,0,1,.322-.764c.647-.631,1.272-1.286,1.974-2,.016.218.03.329.03.44q0,5.622,0,11.245a3.771,3.771,0,0,1-3.835,3.909q-7.4.036-14.806,0a3.773,3.773,0,0,1-3.836-3.869q-.012-7.343,0-14.686a3.775,3.775,0,0,1,3.779-3.928c4.535-.04,9.071-.013,13.605-.012C7669.873,612.923,7669.923,612.936,7670.1,612.96Z",
    transform: "translate(-7652.435 -611.404)",
    fill: "#f16521",
    stroke: "#f16521",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6467",
    "data-name": "Path 6467",
    d: "M7717.534,617.46c-.518.5-1.059,1.012-1.583,1.537-2.767,2.761-5.537,5.515-8.282,8.3a2.785,2.785,0,0,1-.672.508l-3.226-3.226a.989.989,0,0,1,.166-.215q5.046-5.054,10.1-10.1c.056-.056.12-.1.165-.142Z",
    transform: "translate(-7692.183 -614.385)",
    fill: "#f16521",
    stroke: "#f16521",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6468",
    "data-name": "Path 6468",
    d: "M7768.259,608.872l-3.288-3.278a2.287,2.287,0,0,1,3.261-.155A2.312,2.312,0,0,1,7768.259,608.872Z",
    transform: "translate(-7741.952 -606.833)",
    fill: "#f16521",
    stroke: "#f16521",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6469",
    "data-name": "Path 6469",
    d: "M7699.747,676.326a3.147,3.147,0,0,1-.794.293c-.945.224-1.883.478-2.824.715-.446.112-.667-.1-.555-.562q.435-1.785.9-3.56a.478.478,0,0,1,.047-.112Z",
    transform: "translate(-33.058 -57.517)",
    fill: "#f16521",
    stroke: "#f16521",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-icon.55f1d2cacc0be89244f78bde9e2d3e28.svg";